<template>
	<div class="divide-y-2 divide-gray-200">
		<!-- quantity -->
		<div class="flex flex-wrap p-6 gap-x-6 gap-y-4">
			<div class="basis-full sm:basis-[30.75%]">
				<ui-input-group
					v-model="form.qty.mt"
					field="qty.mt"
					label="Quantity in metric tons"
					suffix="t"
					:form="form"
					:required="true"
				></ui-input-group>
			</div>
			<offer-edit-qty-tolerance class="basis-full sm:basis-[30.75%]" :form="form" />
			<ui-check-group
				class="basis-full flex pb-2 mb-px"
				v-model="form.qty.partial_ok"
				field="qty.partial_ok"
				:form="form"
				:required="true"
				label="Partial quantity possible"
				tooltip-text="Target quantity can also be fulfilled by partial quantities."
			>
			</ui-check-group>
		</div>

		<!-- price -->
		<offer-edit-price
			class="p-6"
			:form="form"
			:activeFutures="activeFutures"
			:is-price-required="isPriceRequired"
		/>

		<!-- Location -->
		<offer-edit-location class="p-6" :form="form" />
	</div>
</template>

<script>
export default {
	props: {
		form: {
			type: Object,
			required: true,
		},
		activeFutures: {
			type: Array,
			required: true,
		},
	},
	computed: {
		isPriceRequired() {
			return this.form.trade == "BUY";
		},
	},
};
</script>
